module.exports = __webpack_public_path__ + "static/media/PM38.486db297.png";